<template>
  <div class="table table-hover">
    <b-row class="thead">
      <b-col>
      </b-col>
      <template v-for="col in value.columns">
        <b-col :class="columnClass(col)">{{ formatColumnHeader(col, col.header) }}</b-col>
      </template>
    </b-row>
    <div class="tbody">
      <template v-for="row in value.rows">
        <display-table-row :value="row">
          <template v-slot:value="{ row: r, value: v, index: i }">
            <slot name="value" :row="r" :value="v" :index="i">
              <b-col :class="valueClass(r, v) + ' ' + columnClass(v)">
                {{ formatValue(r, v) }}
              </b-col>
            </slot>
          </template>
        </display-table-row>
      </template>
    </div>
  </div>
</template>
<script>
import { number2text } from 'core/utils';

export function columnClass(col) {
  return "col-1";
}

export function valueClass(row, value) {
  if (typeof value === 'number') {
    let ret = 'text-right';
    if (value && value < 0) {
      ret += ' text-danger';
    }
    return ret;
  }
  return '';
}

export function formatColumnHeader(col, value) {
  return value;
}

export function formatValue(row, value) {
  if (typeof value === 'number') {
    return number2text(value, 2);
  }
  return value;
}

export default {
  props: {
    value: {
      type: Object
    },

    columnClass: {
      type: Function,
      default: columnClass
    },

    valueClass: {
      type: Function,
      default: valueClass
    },

    formatColumnHeader: {
      type: Function,
      default: formatColumnHeader
    },

    formatValue: {
      type: Function,
      default: formatValue
    }
  }
}
</script>
